import { useTranslation } from "react-i18next";
import { Flex, Grid, Stack, Title } from "@mantine/core";

import { CampaignsInSignup } from "./CampaignsInSignup";
import { CampaignsInTesting } from "./CampaignsInTesting";

export const DashboardInProgress = () => {
    const { t } = useTranslation(["common"]);
    return (
        <Stack>
            <Flex
                align="center"
                justify="space-between"
                mt="xl"
                mb="md"
                style={{ borderBottom: "1px solid transparent" }}
            >
                <Title order={3} size={16} style={{ fontWeight: 600 }}>
                    {t("dashboard_in_progress")}
                </Title>
            </Flex>
            <Grid>
                <Grid.Col span={12} md={6}>
                    <CampaignsInTesting />
                </Grid.Col>
                <Grid.Col span={12} md={6}>
                    <CampaignsInSignup />
                </Grid.Col>
            </Grid>
        </Stack>
    );
};
